module.exports = __webpack_public_path__ + "r-v3/img/gooroomee_study_download_image1.2585afb9.png";